const initGallery = () => {
    const config = new CarouselConfig();
    config.sliderSelector = "[data-carousel-gallery]";
    config.cellAlign = CellAlign.center;
    config.contain = true;
    config.autoPlay = false;
    config.wrapAround = false;
    config.showArrows = false;
    config.showArrows = false;
    config.showDots = true;
    config.groupCells = true;
    config.adaptiveHeight = true;
    config.imagesLoaded = true;
    const responsiveCarousel = new ResponsiveCarousel();
    responsiveCarousel.initCarousel(config);
};
